import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import NotFound from './screens/NotFound';
import AppNavigation from './screens/AppNavigation';
import AuthRoute from './components/AuthRoute';
import LoginForm from './components/LoginForm';
import ResetPasswordForm from './components/ResetPasswordForm';
import PasswordResetSuccess from './components/PasswordResetSuccess';

export default () => (
    <>
    <Switch>
        <Route path="/login" component={LoginForm} />
        <Route path="/reset_password/:token" component={ResetPasswordForm} />
        <Route path="/reset_password_success/" component={PasswordResetSuccess} />
        <AuthRoute path="/organisations" component={AppNavigation} />
        <AuthRoute path="/organisation" component={AppNavigation} />
        <Route component={NotFound} />
    </Switch>
    </>
);



// WEBPACK FOOTER //
// ./src/Routes.tsx